import { useOrgMembers } from 'new/hooks/adapters/useOrgMembers';
import { useFilteredData } from 'new/hooks/useFilteredData';

export function useImpersonateUsers(organizationID?: number) {
  const members = useOrgMembers({ orgId: organizationID });
  const { filteredData, onSearchChange } = useFilteredData(members, 'name', 'email');

  return {
    onSearchChange,
    users: filteredData,
  };
}
